import React, { Component } from 'react'
import { Table, Tooltip, Modal, message, Collapse, Form, Select, DatePicker, Button, Radio, Input, Card, Badge } from 'antd'
import NumberFormat from 'react-number-format'
import { connect } from 'dva'
import { Link } from 'dva/router'
import moment from 'moment'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import Currency from 'react-currency-formatter';
import { all } from '../../services/restApi'
import { getTotal, createPassword } from '../../utils'
import IncomeNew from './incomeNew'
import config from '../../utils/config'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const Panel = Collapse.Panel
const FormItem = Form.Item;
const Option = Select.Option;
const MonthPicker = DatePicker.MonthPicker;
const ButtonGroup = Button.Group;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const TextArea = Input.TextArea;

class income extends Component {

	constructor (props) {
        super(props);

        this.state = {
        	query: {},
            hotels: [],
            incomes: [],
            NewIncomeVisible: false,
            newIncomeProps: {incomeType: this.props.params.incomeType},
            skip: 0,
            limit: 1000
        }

        message.config({top: 110, duration: 4});

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId)  {
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
        } else {
            if (this.props.location.pathname === '/incomes/cash_funds/cash_funds' || this.props.location.pathname === '/incomes/cash_funds/others')
                window.history.back()
        }

        /*if (localStorage.getItem('hotelConta')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};*/

        if (this.props.params.incomeType === 'cash_funds_trie' || this.props.params.incomeType === 'others_trie' || this.props.params.incomeType === 'payroll_trie') 
            this.state = {...this.state, currentHotel: null};
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        // Consulta los hoteles
        all('Hotel', {limit: 20}).then((resp) => {
            this.setState({
                hotels: resp.results
            });
        })

        // Consulta el total del mes anterior
        //this.getPreviousTotal();
    }


    /**
    * Se llama antes del render()
    */
    componentWillMount () {
        this.props.dispatch({type:'income/filterSuccess', 
            payload: { incomes: [] }
        });

        this.firstLoad();
    }



    /**
    * Agrupamos: Cada tipo de gastos por fecha de creación
    */
    groupByDate (array, count) {

        let incomesGrouped = _.groupBy(array, function (d) { return moment(d.requestedAt.iso).format('YYYY-MM-DD') });

        Object.keys(incomesGrouped).map((key, index) => {

            let item = {};
            item.requestedAt = {__type: 'Date', iso: key};
            item.isParent =  true;
            item.children =  incomesGrouped[key].reverse();
            item.objectId = createPassword();
            //item.amount_income_total = getTotal(incomesGrouped[key], 'amount_income');
            //item.amount_expense_total = getTotal(incomesGrouped[key], 'amount_expense');
            item.children.map((i) => { i.parentId = item.objectId });

            let incomes_caja = _.filter(incomesGrouped[key], function (i) { return i.chargedTo === 'caja' || !i.chargedTo});
            let incomes_propietario = _.filter(incomesGrouped[key], {chargedTo: 'propietario'});
            let incomes_trie = _.filter(incomesGrouped[key], {chargedTo: 'trie'});

            item.amount_income_total = getTotal(incomes_caja, 'amount_income');
            item.amount_expense_total = getTotal(incomes_caja, 'amount_expense');
            item.amount_expense_propietario_total = getTotal(incomes_propietario, 'amount_expense');
            item.amount_expense_trie_total = getTotal(incomes_trie, 'amount_expense');

            this.state.incomes.push(item);

            if (index === Object.keys(incomesGrouped).length - 1) {
                let total = getTotal(this.state.incomes, 'amount_income_total') - getTotal(this.state.incomes, 'amount_expense_total') - getTotal(this.state.incomes, 'amount_expense_propietario_total')
                this.setState({ currentTotal: total });

                // Incluimos un registro que muestra los totales
                let totals = {
                    isTotal: true,
                    isParent: true,
                    amount_income_total: getTotal(this.state.incomes, 'amount_income_total'),
                    amount_expense_total: getTotal(this.state.incomes, 'amount_expense_total'),
                    amount_expense_propietario_total: getTotal(this.state.incomes, 'amount_expense_propietario_total'),
                    amount_expense_trie_total: getTotal(this.state.incomes, 'amount_expense_trie_total'),
                };

                this.state.incomes.push({...totals, objectId: createPassword()});
                this.state.incomes.unshift({...totals, objectId: createPassword()});

                setTimeout(function() {
                    this.props.dispatch({type: 'app/hideLoadingTable'})
                    this.props.dispatch({type:'income/querySuccess', 
                        payload: { incomes: this.state.incomes }
                    });
                }.bind(this), 500);
            }
        });
    }


    /**
    * Consulta el reporte anterior para saber el saldo
    */
    getPreviousTotal () {
        this.props.form.validateFieldsAndScroll((errors, values) => {
            // Query
            let query = {type: this.props.params.incomeType, status: {$ne: 'requested'}};

            if (this.state.currentHotel) {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
            }

            if (values.custom_date) {
                query.requestedAt = {
                    $gte: {__type: 'Date', iso: new Date(moment(values.custom_date).subtract(1, 'months').startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment(values.custom_date).subtract(1, 'months').endOf('month').format()).toISOString()},
                }
            } else {
                query.requestedAt = {
                    $gte: {__type: 'Date', iso: new Date(moment().subtract(1, 'months').startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment().subtract(1, 'months').endOf('month').format()).toISOString()},
                }
            }

            all('Income', {
                where: query,
                keys: 'amount_expense,amount_income',
                skip: 0, 
                limit: 1000
            }).then(resp => {

                if (resp.results.length > 0) {

                    let previousTotal = getTotal(resp.results, 'amount_income') - getTotal(resp.results, 'amount_expense');
                    this.setState({ previousTotal: previousTotal });
                } else {
                    this.setState({ previousTotal: 0 });
                }

            });
        });
    }


    /**
    * Primera carga
    */
    firstLoad () {
        let query = {type: this.props.params.incomeType, status: {$ne: 'requested'}};
        query.requestedAt = {
            $gte: {__type: 'Date', iso: new Date(moment().startOf('month').format()).toISOString()},
            $lte: {__type: 'Date', iso: new Date(moment().endOf('month').format()).toISOString()},
        };

        if (this.state.currentHotel) {
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
        }

        this.setState({query: query});
        this.props.dispatch({type: 'app/showLoadingTable'})

        all('Income', {
            where: query,
            include: 'hotel,expense,expense.parent_category,createdBy,chargedTo', 
            skip: 0, 
            limit: this.state.limit, 
            count: 1, 
            order: 'requestedAt'
        }).then(resp => {

            this.setState({ skip: this.state.limit, total_items: resp.count });

            if (resp.results.length > 0) {
                this.groupByDate(resp.results, resp.count)
            } else {
                this.props.dispatch({type: 'app/hideLoadingTable'})
                this.setState({ currentTotal: 0 });
            }

        }).catch(e => {
            if (e && e.data) message.error(e.data.error);
            else message.error('Ha ocurrido un error al consultar los registros. Intente más tarde')    
        });
    }


	/**
	* Carga otro bloque de registros
	*/
    loadMore () {
    	if (this.state.skip < this.state.total_items) {

            this.props.dispatch({type: 'app/showLoadingTable'})
            this.setState({ skip: this.state.skip + this.state.limit });

            all('Income', {
                where: this.state.query,
                include: 'hotel,expense,expense.parent_category,createdBy,chargedTo', 
                skip: this.state.skip, 
                limit: this.props.income.limit, 
                count: 1, 
                order: 'requestedAt'
            }).then(resp => {

                if (resp.results.length > 0) {
                    this.groupByDate(resp.results, resp.count)
                } else {
                    this.props.dispatch({type: 'app/hideLoadingTable'})
                    this.setState({ currentTotal: 0 });
                }

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error al consultar otros registros. Intente más tarde')    
            });
    	}
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {
        setTimeout(() => {
            all('Hotel', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkAmount (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.-]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');
        } else {
            callback();
        }
    } 


  	/**
    * Búsqueda
    */
    search (notReload) {
        this.props.dispatch({type: 'app/showLoadingTable'})

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Query
            let query;
            notReload ? query = this.state.query : query = {type: this.props.params.incomeType, status: {$ne: 'requested'}};
                

            if (this.state.currentHotel) {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
            }

        	if (values.hotel && values.hotel.key) {
        		query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key};
        	}

            if (values.custom_date) {
                query.requestedAt ={
                    $gte: {__type: 'Date', iso: new Date(moment(values.custom_date).startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment(values.custom_date).endOf('month').format()).toISOString()},
                }

            } else {
                query.requestedAt = {
                    $gte: {__type: 'Date', iso: new Date(moment().startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment().endOf('month').format()).toISOString()},
                };
            }


            this.setState({query: query});

            all('Income', {
                where: query,
                include: 'hotel,expense,expense.parent_category,createdBy,chargedTo', 
                skip: 0, 
                limit: this.state.limit, 
                count: 1, 
                order: 'requestedAt'
            }).then(resp => {

                //this.getPreviousTotal();
                this.setState({incomes: [], skip: this.state.limit, total_items: resp.count});
                this.props.dispatch({type:'income/filterSuccess', 
                    payload: { incomes: [] }
                });

                if (resp.results.length > 0) {
                    this.groupByDate(resp.results, resp.count);
                } else {
                    this.props.dispatch({type: 'app/hideLoadingTable'})
                    this.setState({ currentTotal: 0 });
                }

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error. Intente más tarde')    
            });
        })
    }


    /**
    * Elimina un registro
    */
    delete_item (item) {
        let dispatch = this.props.dispatch;
        let currentTotal = this.state.currentTotal;
        let currentState = this;

        confirm({
            title: '¿Estás seguro que deseas eliminar el registro?',
            onOk () {
                let total = item.amount_income - item.amount_expense;
                let headings_totals = _.filter(currentState.state.incomes, {isTotal: true});
                headings_totals[0].amount_income_total = headings_totals[0].amount_income_total - item.amount_income;
                headings_totals[1].amount_income_total = headings_totals[1].amount_income_total - item.amount_income;

                currentState.setState({ currentTotal: currentTotal - total });
                dispatch({type: 'income/removeItem', payload: item});
            }
        })
    }


    /**
    * Establece la acción para editar
    */
    setUpdate (item) {
        this.setState({ 
            newIncomeProps: {
                incomeId: item.objectId, 
                parentId: item.parentId, 
                incomeType: this.props.params.incomeType
            }
        });
        this.showModalNewIncome();
    }


    /**
    * Establece la acción para crear
    */
    setCreate (item) {
        this.setState({ newIncomeProps: {incomeType: this.props.params.incomeType} });
        this.showModalNewIncome();
    }


    /**
    * Establece la acción para solicitar
    */
    setRequest (item) {
        var chargedTo = '';
        if (this.props.params.incomeType === 'cash_funds')
            chargedTo = 'trie';
        else
            chargedTo = 'hotel';

        this.setState({ newIncomeProps: {incomeType: this.props.params.incomeType, chargedTo: chargedTo} });
        this.showModalNewIncome();
    }


    /**
    * Actualiza el registro como gasto pagado
    */
    incomePaidout (item) {

        // Model
        let data = {};
        data.objectId = item.objectId;
        data.type = this.props.params.incomeType;
        data.status = 'paidout';
        data.parentId = item.parentId;

        this.props.dispatch({type: 'income/update', payload: data});
    }


    /**
    * Actualiza el registro como gasto comprobado
    */
    checkIncome (item) {

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            let data = {};
            data.objectId = item.objectId;
            data.type = this.props.params.incomeType;
            data.status = 'checked';
            data.parentId = item.parentId;
            data.comments_byChecked = values.comments_byChecked;

            if (values.income_verify)
                _.isNumber(values.income_verify) ? data.income_verify = values.income_verify : data.income_verify = Number(values.income_verify.replace(/[^\d.-]/g, ''))
            else
                data.income_verify = 0;

            if (values.expense_verify)
                _.isNumber(values.expense_verify) ? data.expense_verify = values.expense_verify : data.expense_verify = Number(values.expense_verify.replace(/[^\d.-]/g, ''))
            else
                data.expense_verify = 0;

            this.props.dispatch({type: 'income/update', payload: data});
            this.setState({ showModalCheckIncome: false });
        });
    }


    /**
    * Muestra / Oculta el modal para nuevo ingreso
    */
    showModalNewIncome () { this.setState({ NewIncomeVisible: true }); }
    hideModalNewIncome () { 
        this.setState({ NewIncomeVisible: false }); 
        this.search(true); 
    }


    /**
    * Modales
    */
    showModalCheckIncome (item) { this.setState({ showModalCheckIncome: true, currentIncome: item }); }
    showModalNotes (item) { this.setState({ showModalNotes: true, currentIncome: item }); }


  	/**
    * Render del componente
    */
    render () {
    	const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

	    return (
	        <div className="content-wrapper">
	            <section className="content-header">
	            	<h1>
                        <Link onClick={() => window.history.back() }><i className="fa fa-arrow-circle-left"></i></Link>

                        {this.props.params.incomeType === 'cash_funds' ? 'Caja Hotel' : ''}
                        {this.props.params.incomeType === 'cash_funds_trie' ? 'Caja TRIE' : ''}
                        {this.props.params.incomeType === 'others' || this.props.params.incomeType === 'others_trie' ? 'Pagos Luis' : ''}&nbsp;

                        <div className="pull-right">
                            <Button type='primary'>
                                <Link onClick={this.setCreate.bind(this)} className=""><Icon name="plus" /> Agregar nuevo registro</Link>
                            </Button>&nbsp;
                            {/*this.props.params.incomeType === 'cash_funds' || this.props.params.incomeType === 'cash_funds_trie'
                                ? <Button type='primary'>
                                    <Link onClick={this.setRequest.bind(this)} className=""><Icon name="flag" /> Solicitar movimiento {this.props.params.incomeType === 'cash_funds' ? 'a TRIE' : 'al Hotel'}</Link>
                                </Button>
                                : ''
                            */}
                        </div>
                    </h1>
	            </section>

	            <section className="content">
                    <Collapse defaultActiveKey={['1']} className="marginBottom20">
                        <Panel header="Filtros" key="1">
                            <Form>
                                <div className="row">
                                    {/*!this.state.currentHotel 
                                        ? <div className="col-md-3">
                                            <FormItem label="Hotel" hasFeedback>
                                                {this.props.form.getFieldDecorator('hotel')(
                                                    <Select 
                                                        size='large'
                                                        mode="combobox"
                                                        onChange={this.handleSelectHotelChange.bind(this)}
                                                        filterOption={false}
                                                        labelInValue={true}
                                                        optionLabelProp='label'
                                                        placeholder="Elija el hotel"
                                                        >
                                                        {hotel_options}
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    */}

                                    <div className="col-md-3">
                                        <FormItem label="Mes" hasFeedback>
                                            {this.props.form.getFieldDecorator('custom_date', {
                                                initialValue: moment(new Date, 'YYYY-MM')
                                            })(
                                                <MonthPicker placeholder="Seleccione el mes" />
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3" style={{marginTop: 40}}>
                                        <Button type='primary' onClick={() => this.search()} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                            <Icon name="filter" /> Consultar
                                        </Button>
                                    </div>
                                </div>
                            </Form>
                        </Panel>
                    </Collapse>

	                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                        <div className="box-header with-border">
                            {/*<span className="badge bg-orange">Mes Anterior:</span> <Currency quantity={this.state.previousTotal ? this.state.previousTotal : 0} currency="USD" /> &nbsp;&nbsp;&nbsp;&nbsp;*/}
                            <span className="badge bg-green">Efectivo en Caja</span> <h3><Currency quantity={this.state.currentTotal ? this.state.currentTotal : 0} currency="USD" /></h3>

                            <div className="box-tools pull-right">
                                <Button type='primary'>
                                    <Link to={`/incomes/incomes_report/${this.props.params.incomeType}/${moment(this.props.form.getFieldValue('custom_date')).format('YYYY-MM-DD')}`}><Icon name="file-text" /> Ver reporte conglomerado</Link>
                                </Button>
                            </div>
                        </div>

	                    <div className="box-body">
	                        <div className="row">
	                            <div className="col-xs-12">
	                            	<div className="table-responsive table">

		                            	<InfiniteScroll
										    padding={50}
									        throttle={100}
									        onScroll={() => this.loadMore()}>

		                                    <Table 
		                                    	dataSource={this.props.income.incomes} 
		                                    	rowKey="objectId" 
		                                    	size="middle" 
		                                    	loading={this.props.app.loadingTable} 
		                                    	pagination={false}
                                                rowClassName={(record, index) => {
                                                    if (record.isTotal) {
                                                        return 'bg-head-table'
                                                    }
                                                }}>>

		                                    	<Column title="Fecha" key="requestedAt" width={135} render={(item) => (
		                                        	<span>
                                                        {item.isParent && item.requestedAt ? moment(item.requestedAt.iso).format('DD/MM/YYYY') : ''}
                                                        {!item.isParent && !item.status || item.status === 'pending' 
                                                            ? <span><Badge status="warning" /><small>Pendiente</small></span>
                                                            : ''
                                                        }
                                                        {!item.isParent && item.status === 'paidout' 
                                                            ? <span><Badge status="success" /><small>Pagado</small></span>
                                                            : ''
                                                        }
                                                        {!item.isParent && item.status === 'checked' 
                                                            ? <span><Icon name="check" className="color-blue" /> <small>Comprobado</small></span>
                                                            : ''
                                                        }
                                                    </span>
		                                        )} />
                                                {!this.state.currentHotel
    		                                      ? <Column title="Hotel" key="hotel" render={(item) => (
    		                                        	<span>{item.hotel ? item.hotel.name : '-'}</span>
    		                                        )} />
                                                    : ''
                                                }
                                                {this.props.app.user && this.props.app.user.type === 'administrador'
                                                  ? <Column title="Creado por" key="createdBy" render={(item) => (
                                                        <span>{item.createdBy ? item.createdBy.name : '-'}</span>
                                                    )} />
                                                    : ''
                                                }
                                                {this.props.params.incomeType !== 'others'
                                                    ? <Column title="Empleado" key="user" render={(item) => (
                                                        <span>{item.user ? item.user : '-'}</span>
                                                    )}/>
                                                    : ''
                                                }
		                                        <Column title="Tipo de gasto" key="expense" render={(item) => (
                                                    <span>
                                                        {item.expense && item.expense.parent_category ? <span>{item.expense.parent_category.name}<br /></span> : ''}
        		                                        <small>{item.expense ? item.expense.name : ''}</small>
                                                    </span>
		                                        )}/>
		                                        <Column title="Descripción" render={(item) => (
                                                    <span>{item.items ? item.items : ''}</span>
                                                )}/>
                                                {this.state.currentHotel
                                                    ? <Column title={"Efectivo " + this.state.currentHotel.chief} key="amount_expense_propietario_total" render={(item) => (
                                                        <span>
                                                            <Tooltip placement="right" title={"Efectivo " + this.state.currentHotel.chief}>
                                                                {item.isParent
                                                                    ? <span style={{color: item.amount_expense_propietario_total ? 'deeppink' : 'gainsboro'}}><Currency quantity={item.amount_expense_propietario_total ? item.amount_expense_propietario_total : 0} currency="USD" /></span>
                                                                    : <span>
                                                                        {item.amount_expense && item.chargedTo === 'propietario'
                                                                            ? <span style={{color: 'deeppink'}}><Currency quantity={item.amount_expense} currency="USD" /></span>
                                                                            : '-'
                                                                        }
                                                                    </span>
                                                                }
                                                            </Tooltip>
                                                        </span>
                                                    )}/>
                                                    : ''
                                                }
		                                        <Column title="Ingreso" key="amount_income" render={(item) => (
                                                    <span>
                                                        <Tooltip placement="right" title="Ingreso">
                                                            {item.isParent
                                                                ? <span style={{color: item.amount_income_total ? 'dodgerblue' : 'gainsboro'}}><Currency quantity={item.amount_income_total ? item.amount_income_total : 0} currency="USD" /></span>
                                                                : <span>
                                                                    {item.amount_income && (item.chargedTo === 'caja' || !item.chargedTo)
                                                                        ? <span style={{color: 'dodgerblue'}}><Currency quantity={item.amount_income} currency="USD" /></span>
                                                                        : '-'
                                                                    }
                                                                </span>
                                                            }
                                                        </Tooltip>
                                                    </span>
                                                )}/>
                                                <Column title="Egreso" key="amount_expense" render={(item) => (
                                                    <span>
                                                        <Tooltip placement="right" title="Egreso">
                                                            {item.isParent
                                                                ? <span style={{color: item.amount_expense_total ? 'red' : 'gainsboro'}}><Currency quantity={item.amount_expense_total ? item.amount_expense_total : 0} currency="USD" /></span>
                                                                : <span>
                                                                    {item.amount_expense && (item.chargedTo === 'caja' || !item.chargedTo)
                                                                        ? <span style={{color: 'red'}}><Currency quantity={item.amount_expense} currency="USD" /></span>
                                                                        : '-'
                                                                    }
                                                                </span>
                                                            }
                                                        </Tooltip>
                                                    </span>
                                                )}/>
                                                <Column title="Pagos Directos TRIE" key="amount_expense_trie_total" render={(item) => (
                                                    <span>
                                                        <Tooltip placement="right" title="Pagos Directos TRIE">
                                                            {item.isParent
                                                                ? <span style={{color: item.amount_expense_trie_total ? 'orange' : 'gainsboro'}}><Currency quantity={item.amount_expense_trie_total ? item.amount_expense_trie_total : 0} currency="USD" /></span>
                                                                : <span>
                                                                    {item.amount_expense && item.chargedTo === 'trie'
                                                                        ? <span style={{color: 'orange'}}><Currency quantity={item.amount_expense} currency="USD" /></span>
                                                                        : '-'
                                                                    }
                                                                </span>
                                                            }
                                                        </Tooltip>
                                                    </span>
                                                )}/>
		                                        <Column title="Acciones" key="action" width={170}
                                                    render={(item) => (
                                                        <span className="actions">
                                                            {!item.isParent
                                                                ? <ButtonGroup>
                                                                    {!item.notEdit
                                                                        ? <Tooltip placement="bottom" title="Editar">
                                                                            <Button>
                                                                                <Link onClick={() => { this.setUpdate(item) }}><Icon name="edit" /></Link>
                                                                            </Button>
                                                                        </Tooltip>
                                                                        : ''
                                                                    }

                                                                    {item.notes || item.comments_byChecked
                                                                        ? <Tooltip placement="bottom" title="Ver notas">
                                                                            <Button>
                                                                                <Link onClick={() => { this.showModalNotes(item) }}><Icon name="comment" /></Link>
                                                                            </Button>
                                                                        </Tooltip>
                                                                        : ''
                                                                    }

                                                                    {item.picture
                                                                        ? <Tooltip placement="bottom" title="Ver comprobante">
                                                                            <Button>
                                                                                <a href={config.externalUrl + 'uploads/docs/' + item.picture} target="_blank"><Icon name="paperclip" /></a>
                                                                            </Button>
                                                                        </Tooltip>
                                                                        : ''
                                                                    }

                                                                    {(!item.status || item.status === 'pending') && this.props.app.user && this.props.app.user.type === 'administrador'
                                                                        ? <Tooltip placement="bottom" title="Pagado">
                                                                            <Button>
                                                                                <Link onClick={() => { this.incomePaidout(item) }}><Icon name="check" /></Link>
                                                                            </Button>
                                                                        </Tooltip>
                                                                        : ''
                                                                    }

                                                                    {item.status === 'paidout' && this.props.app.user && this.props.app.user.type === 'administrador'
                                                                        ? <Tooltip placement="bottom" title="Comprobado">
                                                                            <Button>
                                                                                <Link onClick={() => { this.showModalCheckIncome(item) }}><Icon name="check-circle" /></Link>
                                                                            </Button>
                                                                        </Tooltip>
                                                                        : ''
                                                                    }

                                                                    <Tooltip placement="bottom" title="Eliminar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.delete_item(item) }} className=""><Icon name="trash" /></Link>
                                                                        </Button>
                                                                    </Tooltip>
                                                                </ButtonGroup>
                                                                : ''
                                                            }
                                                        </span>
                                                    )}
                                                />
		                                    </Table>        
			                            </InfiniteScroll>
		                            </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </section>

                <Modal
                    width={800}
                    visible={this.state.NewIncomeVisible}
                    title="Movimiento del Hotel"
                    onCancel={this.hideModalNewIncome.bind(this)}
                    footer={[]} 
                >
                    {this.state.NewIncomeVisible
                        ? <IncomeNew {...this.state.newIncomeProps} />
                        : ''
                    }
                </Modal>

                <Modal
                    visible={this.state.showModalCheckIncome}
                    title="Comprobación de ingresos / gastos"
                    onCancel={() => { this.setState({ showModalCheckIncome: false }); }}
                    footer={[
                        <Button key="back" onClick={() => { this.setState({ showModalCheckIncome: false }); }}>Cerrar</Button>,
                        <Button key="details" type="primary" onClick={() => { this.checkIncome(this.state.currentIncome) }}>
                            <Icon name="check" /> Comprobado
                        </Button>
                    ]} 
                >
                    {this.state.showModalCheckIncome
                        ? <div className="row">
                            {this.state.currentIncome.expense.allow_income
                                ? <div className="col-md-6">
                                    <FormItem label="Ingreso comprobado" hasFeedback>
                                        {this.props.form.getFieldDecorator('income_verify', {
                                            initialValue: this.state.currentIncome.amount_income,
                                            rules: [{
                                                required: true,
                                                message: 'Por favor, ingrese el monto real comprobado'
                                            }, {
                                                validator: this.checkAmount.bind(this)
                                            }]
                                        })(
                                            <NumberFormat 
                                                thousandSeparator={true} 
                                                prefix={'$'} 
                                                className="ant-input ant-input-lg" />
                                        )}
                                    </FormItem>
                                </div>
                                : ''
                            }

                            {this.state.currentIncome.expense.allow_expense
                                ? <div className="col-md-6">
                                    <FormItem label="Gasto comprobado" hasFeedback>
                                        {this.props.form.getFieldDecorator('expense_verify', {
                                            initialValue: this.state.currentIncome.amount_expense,
                                            rules: [{
                                                required: true,
                                                message: 'Por favor, ingrese el monto real comprobado'
                                            }, {
                                                validator: this.checkAmount.bind(this)
                                            }]
                                        })(
                                            <NumberFormat 
                                                thousandSeparator={true} 
                                                prefix={'$'} 
                                                className="ant-input ant-input-lg" />
                                        )}
                                    </FormItem>
                                </div>
                                : ''
                            }

                            <div className="col-md-12">
                                <FormItem label="Comentarios" hasFeedback>
                                    {this.props.form.getFieldDecorator('comments_byChecked')(<TextArea rows={3} />)}
                                </FormItem>
                            </div>
                        </div>
                        : ''
                    }
                </Modal>

                <Modal
                    visible={this.state.showModalNotes}
                    title="Notas"
                    onCancel={() => { this.setState({ showModalNotes: false }); }}
                    footer={[]} 
                >
                    {this.state.showModalNotes
                        ? <span>
                            <Card title="Notas generales" className="marginBottom20">
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.currentIncome.notes}
                                    </div>
                                </div>
                            </Card>

                            <Card title="Notas al comprobar el movimiento" className="marginBottom20">
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.currentIncome.comments_byChecked}
                                    </div>
                                </div>
                            </Card>
                        </span>
                        : ''
                    }
                </Modal>
	        </div>
	    )
	}
}

export default connect(({income, app}) => ({income, app}))(Form.create()(income))


// WEBPACK FOOTER //
// ./src/components/incomes/cashFunds.js